/**
 * Interpreta o processo selecionado no admin (valor vindo do select de processo).
 * Evita tratar NaN como "sem filtro" e expor todos os analistas por engano.
 *
 * @param {string|number|null|undefined} selectedProcessId
 * @returns {{ empty: boolean, invalid: boolean, id: number|null }}
 *   - empty: nada selecionado ('' / null / undefined)
 *   - invalid: valor preenchido mas não é número inteiro válido
 *   - id: id numérico apenas quando seleção válida
 */
export function parseAdminSelectedProcessId(selectedProcessId) {
  const raw = selectedProcessId;
  if (raw === '' || raw == null) {
    return { empty: true, invalid: false, id: null };
  }
  const id = parseInt(String(raw).trim(), 10);
  if (!Number.isFinite(id)) {
    return { empty: false, invalid: true, id: null };
  }
  return { empty: false, invalid: false, id };
}
